import config from 'config-base';

import Accordion from '@base/components/src/Accordion';
import FooterLinks from '../FooterLinks';

import styles from './FooterNavigation.module.css';


const FooterNavigation = () => {
  const customerSupportLinks = (
    <FooterLinks
      links={[
        { title: 'Contact Us', href: config.contactUsUrl },
        { title: 'Track Order', href: config.orderTrackingUrl },
        { title: 'FAQ', href: config.faqUrl },
        { title: 'Account', href: config.signInUrl },
        { title: 'Bullseye Bucks', href: config.bullseyeBucksAboutUrl },
        { title: 'Gift eCards', href: config.giftCardsUrl },
      ]}
    />
  );

  const shippingServiceLinks = (
    <FooterLinks
      links={[
        { title: 'Build Custom Airgun', href: config.airGunBuilderUrl },
        { title: 'Product Finder', href: config.productFinderUrl },
        { title: 'Hunting Laws by State', href: config.airgunMapUrl },
        { title: 'Brands', href: config.airgunsByBrandUrl },
        { title: 'Catalog', href: config.requestCatalogUrl },
        { title: 'Safety', href: config.airgunSafetyUrl },
      ]}
    />
  );

  const companyLinks = (
    <FooterLinks
      links={[
        { title: 'About Us', href: config.aboutUsUrl },
        { title: 'Resources', href: config.airgunResourcesUrl },
        { title: 'Affiliate Program', href: config.affiliateProgramUrl },
        { title: 'Become a Seller', href: config.sellerUrl },
        { title: 'Dealers', href: config.dealersUrl, rel: 'noreferrer' },
        { title: 'Careers', href: config.careersUrl },
      ]}
    />
  );

  return (
    <>
      <div className={styles.footerNavigationContainer}>
        <Accordion
          title="Customer Support"
          className={styles.footerAccordion}
          headerClassName={styles.footerAccordionHeader}
          titleClass={styles.footerAccordionTitle}
          contentClassName={styles.footerAccordionContent}
          hidePlusIcon
          iconClassName={styles.footerPlusIcon}
          rippleClassName={styles.footerRipple}
        >
          {customerSupportLinks}
        </Accordion>
        <Accordion
          title="Shopping Services"
          className={styles.footerAccordion}
          headerClassName={styles.footerAccordionHeader}
          titleClass={styles.footerAccordionTitle}
          contentClassName={styles.footerAccordionContent}
          hidePlusIcon
          iconClassName={styles.footerPlusIcon}
          rippleClassName={styles.footerRipple}
        >
          {shippingServiceLinks}
        </Accordion>
        <Accordion
          title="Get To Know Us"
          className={styles.footerAccordion}
          headerClassName={styles.footerAccordionHeader}
          titleClass={styles.footerAccordionTitle}
          contentClassName={styles.footerAccordionContent}
          hidePlusIcon
          iconClassName={styles.footerPlusIcon}
          rippleClassName={styles.footerRipple}
        >
          {companyLinks}
        </Accordion>
      </div>

      <div className={styles.footerNavigation}>
        <div className={styles.footerNavigationSection}>
          <div className={styles.footerNavigationSectionTitle}>Customer Support</div>
          {customerSupportLinks}
        </div>

        <div className={styles.footerNavigationSection}>
          <div className={styles.footerNavigationSectionTitle}>Shopping Services</div>
          {shippingServiceLinks}
        </div>

        <div className={styles.footerNavigationSection}>
          <div className={styles.footerNavigationSectionTitle}>Get To Know Us</div>
          {companyLinks}
        </div>
      </div>
    </>
  );
};

export default FooterNavigation;
